import React, { useState,useEffect} from "react";
import LayerAdmin from "../LayerAdmin";
import { toast } from "react-toastify";
import ButtonLoader from "../../zamzam/components/ButtonLoader";
import { useNavigate ,useParams} from "react-router-dom";
import URL_MAPPING from "../../../routes/constants";
import { addNewPerm,getDropdownsales,getDropdownchannel,getDropdownEmp,addTarget } from "../api/auth";
type SalesOffice = {
  emp_id: string;
  name_eng: string;
  available_emp: string
  
};
type Channel = {
  channel_id: string;
  name: string;
  available_emp: string
};

const Assignrole = () => {
  const [formData, setFormData] = useState({
    id: "",
    values:"",
    available_emp:"",
    // session_entity_key: "",
    // territory_entity_key: "",
  });
    const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [invalidFields, setInvalidFields] = useState<string[]>([]);
  const [values, setValues] = useState<SalesOffice[]>([]);
  const [valuesChannel, setValuesChannel] = useState<Channel[]>([]);
  const navigate = useNavigate();

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const getInputClass = (field: string) =>
    `w-full border px-3 py-2 rounded ${
      invalidFields.includes(field) ? "border-red-500" : ""
    }`;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // const payload = {
    //   role_id : formData.id,
    //   emp_ids: formData.values,
    //   channel_ids: formData.values,
    //   // region_entity_key: formData.region_entity_key,
    //   // session_entity_key: formData.session_entity_key,
    //   // territory_entity_key: formData.territory_entity_key,
    // };


    try {
      setLoading(true);
      // const emptyFields = Object.entries(formData)
      //   .filter(([_, value]) => value === null || value === "")
      //   .map(([key]) => key);

      // setInvalidFields(emptyFields);
      setInvalidFields([]);

      // if (emptyFields.length > 0) {
      //   toast.error("Please fill all required fields.");
      //   return;
      // }
      let temp ="000104"
      const payload = new FormData();
      payload.append("role_id", id || "");
      // payload.append("emp_id",  temp    || "");
      payload.append("emp_id", formData.available_emp || "");

 
      const response = await addTarget(payload);
      if (!response) {
        toast.error("No data received or malformed response");
        console.warn("No data received or malformed response:", response);
        return;
      }
      toast.success(response?.message);
      setTimeout(() => {
        navigate(URL_MAPPING.AUTH);
      }, 2000);
    } catch (error: any) {
      console.error("Failed to fetch  data:", error);
      if (error?.response?.status === 404) {
        toast.error(error?.response?.status);
      } else if (error?.response?.status === 500) {
        toast.error(error.response.data.detail);
      } else {
        const detail = error?.response?.data?.detail;
        if (Array.isArray(detail)) {
          detail.forEach((err) => toast.error(err.msg));
        } else {
          toast.error(detail?.msg || detail || "An unexpected error occurred.");
        }
      }
    } finally {
      setLoading(false);
    }
  };


 
 
  return (
    <LayerAdmin>
      <div className="flex items-center px-5 pt-5 gap-3">
        <button
          onClick={() => window.history.back()}
          className="bg-gray-200 text-gray-700 px-4 py-2 rounded hover:bg-gray-300"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            version="1.1"
            width="10"
            height="10"
            viewBox="0 0 256 256"
            xmlSpace="preserve"
          >
            <g
              style={{
                stroke: "none",
                strokeWidth: 0,
                strokeDasharray: "none",
                strokeLinecap: "butt",
                strokeLinejoin: "miter",
                strokeMiterlimit: 10,
                fill: "none",
                fillRule: "nonzero",
                opacity: 1,
              }}
              transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
            >
              <polygon
                points="20.48,45 59.75,90 69.52,81.48 37.69,45 69.52,8.52 59.75,0 "
                style={{
                  stroke: "none",
                  strokeWidth: 1,
                  strokeDasharray: "none",
                  strokeLinecap: "butt",
                  strokeLinejoin: "miter",
                  strokeMiterlimit: 10,
                  fill: "rgb(0,0,0)",
                  fillRule: "nonzero",
                  opacity: 1,
                }}
                transform="  matrix(1 0 0 1 0 0) "
              />
            </g>
          </svg>
        </button>
        <h3 className="text-xl font-bold text-gray-700">Assign Role</h3>
      </div>
      <form onSubmit={handleSubmit} className="p-4 lg:w-1/3 sm:w-full">
        <div className="my-2">
          <label className="block font-semibold mb-1">Roles ID</label>
          <input
            type="text"
            name="id"
            disabled
            value={id}
            onChange={handleChange}
            className={getInputClass("id")}
            placeholder="Employee Id"
          />
        </div>


  <div className="my-2">
          <label className="block font-semibold mb-1">Select Available Employee</label>
          <input
            type="text"
            name="available_emp"
           
            value={formData.available_emp}
            onChange={handleChange}
            className={getInputClass("available_emp")}
            placeholder="Employee Id"
          />

        </div>
    
        <button
          type="submit"
          disabled={loading}
          className="bg-teal-500 text-white px-6 py-2 rounded hover:bg-teal-600 flex items-center gap-2"
        >
        Assign Role {loading && <ButtonLoader />}
        </button>
      </form>
    </LayerAdmin>
  );
};

export default Assignrole;
